import _ from 'lodash';

export interface PaginationStrategy<TResponse> {
  getQueryParams?: (lastResponse: TResponse | null) => any;
  hasNextPage: (lastResponse: TResponse) => boolean;
  buildNextQuery: (lastResponse: TResponse, originalQuery: any) => any;
  mergeResponses: (responses: TResponse[]) => TResponse;
}

/**
 * Use when it's certain that there is no pagination required for the particular fhir search query
 */
export const singlePageStrategy: PaginationStrategy<any> = {
  getQueryParams: () => ({}),
  hasNextPage: () => false,
  buildNextQuery: (_lastResponse: any, originalQuery: any) => originalQuery,
  mergeResponses: (responses: any[]) => responses[0],
};

export type ScrollQueryResult<THit = any> = {
  _scroll_id?: string;
  hits: {
    hits: THit[];
  };
};

/**
 * Use when not doing aggregations to do standard es pagination
 */
export const scrollPageStrategy: PaginationStrategy<ScrollQueryResult> = {
  getQueryParams: (lastResponse: ScrollQueryResult | null) => {
    if (lastResponse === null) {
      return { scroll: 'true' };
    } else if (lastResponse?._scroll_id) {
      return { scroll: lastResponse?._scroll_id };
    } else {
      return {};
    }
  },
  hasNextPage: response => !!response?.hits?.hits?.length,
  buildNextQuery: (_lastResponse: any, originalQuery: any) => originalQuery,
  mergeResponses: (responses: ScrollQueryResult[]) => {
    const refResult = _.cloneDeep(responses[0]);
    const allResults = responses.map(_ => _?.hits?.hits || []).filter(Boolean);
    refResult.hits.hits = _.flatten(allResults);
    return refResult;
  },
};
